export default function splitOnFirst(string, separator) {
  if (!(typeof string === 'string' && typeof separator === 'string')) {
    throw new TypeError('Expected the arguments to be of type `string`');
  }

  if (string === '' || separator === '') {
    return [];
  }

  var separatorIndex = string.indexOf(separator);

  if (separatorIndex === -1) {
    return [];
  }

  return [string.slice(0, separatorIndex), string.slice(separatorIndex + separator.length)];
}